<template>
  <div class="c-filter">
    <div class="c-form">
      <el-form label-width="70px" inline class="elementui-common-form-styles" v-highlight>
        <el-form-item>
          <ElInput v-model="keyword" placeholder="请输入素材ID或者名称" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </el-form-item>
        <el-form-item label-width="90px" label="一级素材样式">
          <el-select
            style="width: 170px"
            v-model="imageStyles"
            @change="sendEvent"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
          >
            <el-option v-for="item in materialStyleInFirstLevel" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="90px" label="二级素材样式">
          <el-select
            style="width: 170px"
            v-model="imageStyles2"
            @change="sendEvent"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
          >
            <el-option v-for="item in materialStyleInSecLevel" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目组" label-width="60">
          <ThrottleSelector
            v-model="projectId"
            :list="projectData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>

        <el-form-item label="设计人员">
          <ThrottleSelector
            v-model="agentId"
            :list="agentData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>

        <el-form-item label="游戏" label-width="40">
          <ThrottleSelector
            v-model="gameId"
            :list="gameData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </el-form-item>

        <el-form-item label="素材类型">
          <el-select v-model="imageId" style="width: 80px" @change="sendEvent">
            <el-option :value="-1" label="不限"></el-option>
            <el-option :value="1" label="图片"></el-option>
            <el-option :value="2" label="视频"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="月份" label-width="40">
          <ElDatePicker
            type="month"
            v-model="month"
            value-format="yyyy-MM"
            :picker-options="datetimeOption"
            :clearable="false"
            placeholder="不限"
            style="width: 100px"
            @change="sendEvent(), getLockState()"
          >
          </ElDatePicker>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-row">
      <div class="freeze-data" v-if="authLock">
        <switch-plus v-model="lock" :before-change="lockEvent" />
        <span class="freeze-text">冻结数据</span>
      </div>

      <ElButton type="primary" @click="$emit('on-export')">数据导出</ElButton>

      <ElButton :loading="syncing" :disabled="lock" @click="$emit('on-sync')">
        <span v-if="syncing">同步中...</span>
        <span v-else>
          <Icon type="md-sync" size="12" />
          <span>同步数据</span>
        </span>
      </ElButton>

      <ElButton @click="$emit('on-custom-col')">自定义列</ElButton>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { trim } from '@/common/js/utils'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import SwitchPlus from '@/components/switch-plus'
import { syncDesignReportLock, getDesignReportLock } from '@/api/manage.model'
import { initPageData, SYS_TAGS } from '@/data/global-opts'
import { LABEL_TYPES, LEVEL_TYPES } from '@/views/material/tags/const'

const PAGE_REQUIRED_OPTS = initPageData([SYS_TAGS])

export default {
  name: 'designFilter',
  components: { ThrottleSelector, SwitchPlus },
  props: {
    agentData: {
      type: Array,
      default() {
        return []
      }
    },
    gameData: {
      type: Array,
      default() {
        return []
      }
    },
    projectData: {
      type: Array,
      default() {
        return []
      }
    },
    syncing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    labelList() {
      return {
        materialStyleLabels: this.SYS_TAGS.filter((i) => i.labelType === LABEL_TYPES.MATERIAL_STYLE_LABEL)
      }
    },
    materialStyleInFirstLevel() {
      return this.labelList.materialStyleLabels.filter((i) => i.level === LEVEL_TYPES.LEVEL_ONE)
    },
    materialStyleInSecLevel() {
      const levelTwo = this.labelList.materialStyleLabels.filter((tag) => tag.level === LEVEL_TYPES.LEVEL_TWO)
      if (!this.imageStyles?.length) return levelTwo
      // 如果有一级样式，就返回一级样式下的二级样式
      return levelTwo.filter((tag) => {
        return this.imageStyles.some((id) => id === tag.parentId)
      })
    },
    authDesign() {
      return this.access.includes('M20827')
    },
    authLock() {
      return this.access.includes('M20826')
    }
  },
  methods: {
    buildParams() {
      const labelIds = [this.imageStyles, this.imageStyles2].filter((i) => Array.isArray(i)).flat()
      return {
        labelIdsStr: labelIds.join(','),
        designerId: this.agentId === '' ? undefined : this.agentId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        imageType: this.imageId === -1 ? undefined : this.imageId,
        projectGroupId: this.projectId === '' ? undefined : this.projectId,
        reportMonth: this.month === '' ? undefined : this.month,
        keyWord: trim(this.keyword)
      }
    },
    sendEvent() {
      this.$emit('on-change', this.buildParams())
    },

    lockEvent() {
      return new Promise((resolve, reject) => {
        this.$Spin.show()

        syncDesignReportLock({ reportMonth: this.month, lock: Boolean(!this.lock) })
          .then((data) => {
            this.$Spin.hide()
            data && resolve()
          })
          .catch(() => {
            this.$Spin.hide()
            reject(new Error('冻结数据失败！'))
          })
      })
    },
    getLockState() {
      getDesignReportLock({ reportMonth: this.month }).then((data) => {
        this.lock = Boolean(data)
      })
    }
  },
  data() {
    return {
      keyword: '',
      access: this.$store.state.accessAuth,
      month: '', // 月份
      agentId: '', // 人员id
      gameId: '',
      projectId: '',
      imageId: -1,
      imageStyles: [],
      imageStyles2: [],
      lock: null,
      datetimeOption: {
        disabledDate(date) {
          if (date) return date.valueOf() > Date.now() || date.valueOf() < new Date('2019-01-01 00:00:00')
          else return false
        }
      }
    }
  },
  created() {
    this.month = moment().subtract(2, 'months').format('YYYY-MM')
    // 初始化
    this.sendEvent()
  }
}
</script>
<style lang="scss" scoped>
.c-filter {
  margin-bottom: 5px;
  .table-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .freeze-data {
      display: flex;
      align-items: center;
      margin-right: 8px;
      .freeze-text {
        font-size: 14px;
      }
    }
  }
}
</style>
